export default __webpack_public_path__ + "static/media/contact.95643ab7.svg";